export const VISITOR_DATA_PREFIX = 'visitor_data_' as const;
export const DEPRECATED_SPLIT_KEY_PREFIX = 'data-split-' as const;
